export default "__VITE_ASSET__CFKr$BuE__"